"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpHeroVX = void 0;
const tmpls_1 = require("./tmpls");
const BiMath_1 = require("../BiMath");
const CmpModalDialog_1 = require("./CmpModalDialog");
class CmpHeroVX extends tmpls_1.CmpHeroVXBase {
    constructor() {
        super();
        this.ctrls.lAPR.text = "Loading";
        this.ctrls.btnInfo.onclick = () => CmpModalDialog_1.CmpModalDialog.DialogOk(this.ctrls.lBtnInfo.text).show();
    }
    showAPR(vxAprBI) {
        return __awaiter(this, void 0, void 0, function* () {
            const apr = BiMath_1.BiMath.ToEth(vxAprBI);
            if (vxAprBI == BiMath_1.BiMath.Zero)
                this.ctrls.lAPR.text = "Calculating";
            else {
                let acc = 1;
                const daily = 1 + parseFloat(apr) / 365 * 0.91;
                for (let d = 0; d < 365; d++)
                    acc = acc * daily;
                acc = acc - 1;
                this.ctrls.lAPR.text = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(BiMath_1.BiMath.ToBI(acc + "") * BigInt(100)), 3) + "%";
            }
        });
    }
}
exports.CmpHeroVX = CmpHeroVX;
//# sourceMappingURL=CmpHeroVX.js.map